import { render } from "./SubscriptionCancel.vue?vue&type=template&id=8154543c"
import script from "./SubscriptionCancel.vue?vue&type=script&lang=js"
export * from "./SubscriptionCancel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__